import React, {useContext} from "react";
import {CardActionArea} from "@material-ui/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/pro-light-svg-icons/faArrowLeft";
import {faArrowCircleLeft} from "@fortawesome/pro-solid-svg-icons";
import {useHistory} from "react-router-dom";
import {AppContext} from "../App";
import {ITopNavbar} from "../interfaces/ITopNavbar";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

function TopNavBar(p: ITopNavbar) {

    let history = useHistory();
    const context = useContext(AppContext);
    const currentStepNo = Number(context.currentStepNo);

    function navigateBack(){
        // if(currentStepNo <= 0) {
        //     history.goBack();
        // } else {
        //     let step: number = currentStepNo;
        //     step--;
        //     context.setCurrentStepNo(step);
        // }
        history.goBack()
    }

    return (
        <div className={'top-navbar'}>
            <CardActionArea className={'back-btn'} onClick={navigateBack}>
                <FontAwesomeIcon icon={faArrowLeft} className={'icon-mobile'}/>
                <FontAwesomeIcon icon={faArrowCircleLeft} className={'icon-desktop'}/>
            </CardActionArea>
            <CardActionArea className={'back-btn-home'} onClick={()=>{
                history.push(`/home/${context.deviceId}/${context.recoveryId}`);
            }}>
                <div>Back To All Weeks</div>
            </CardActionArea>
            <div className={'nav-label'}>
                Week {p.weekNo}
                {(!p.lessonNo || p.lessonNo === 0) ? "" : <><FiberManualRecordIcon
                    style={{fontSize: 8, paddingLeft: 6, paddingRight: 6, paddingTop: 8}}/>
                    <div>{`Lesson ${p.lessonNo}`}</div>
                </> }
            </div>
        </div>
    )
}

export default TopNavBar;